import { IdName } from 'src/app/shared/models/id-name';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IListSeverityModel } from '../../models/severities/list-severity.model';
import { INewSeverityModel } from '../../models/severities/new-severity.model';
import { ISeverityModel } from '../../models/severities/severity.model';

@Injectable({
  providedIn: 'root',
})
export class SeverityApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/NonConformance/Severities`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: new HttpParams(),
  };

  constructor(private httpClient: HttpClient) {}

  getSeverities(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IListSeverityModel[]>> {
    let url = `${this.baseUrl}/Paged`;
    if (currentFilter) {
      url = `${url}?Page=${currentFilter.pageIndex}&PageSize=${currentFilter.pageSize}`;
    }
    if (currentFilter?.searchTerm) {
      url = `${url}&GlobalSearch=${currentFilter.searchTerm}`;
    }
    if (currentFilter?.orderBy && currentFilter.ascDesc) {
      url = `${url}&OrderBy[${currentFilter.orderBy}]=${currentFilter.ascDesc}`;
    }
    return this.httpClient.get<ApiResponse<IListSeverityModel[]>>(url, this.httpOptions);
  }

  getAllSeverities(): Observable<IdName[]> {
    return this.httpClient.get<IListSeverityModel[]>(this.baseUrl, this.httpOptions);
  }

  getSeverityById(id: string): Observable<ISeverityModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.httpClient.get<ISeverityModel>(url, this.httpOptions);
  }

  createSeverity(severity: INewSeverityModel): Observable<IListSeverityModel> {
    return this.httpClient.post<IListSeverityModel>(this.baseUrl, severity, this.httpOptions);
  }

  updatedSeverity(severity: IListSeverityModel): Observable<IListSeverityModel> {
    return this.httpClient.put<IListSeverityModel>(this.baseUrl, severity, this.httpOptions);
  }

  deleteSeverity(severityId: string): Observable<IListSeverityModel> {
    const url = `${this.baseUrl}/${severityId}`;
    return this.httpClient.delete<IListSeverityModel>(url);
  }
}
